import React, { useCallback, useEffect, useState } from 'react';
import { PasswordSettings } from './PasswordSettings';
import { Button, Dialog, DialogContent, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { updateUsersPasswordTC, UserType } from './users-reducer';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

type PropsType = {
  user: UserType
}

export const AlertDialogPassword = React.memo((props: PropsType) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false)
  const [span, setSpan] = useState('none')

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
    setSpan('none')
  }, []);

  async function setNewPassword(newPassword: string) {
    let user = props.user
    user.password = newPassword
    await dispatch(updateUsersPasswordTC({user}))
    setSpan('inline')
    navigate(`/usersList/${user.id}`, { state: {user: user} })
  }

   return (
    <>
     <Button variant="text" style={{color:'#24bced', textTransform: 'none',position: 'absolute',textDecoration: 'underline', bottom: '0px'}}  onClick={handleClickOpen} >Change password</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container style={{justifyContent: 'end' }}>
          <Grid item >
            <CloseIcon onClick={handleClose} style={{marginRight:' 2px', cursor: 'pointer'}} />
          </Grid>
        </Grid>
        <DialogContent >
          <Grid container >
            <PasswordSettings span={span} setNewPassword={setNewPassword} />
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
 }
)